/**
 * @author       matthew@zumper.com (Matthew Talamini)
 * @copyright    Copyright (c) 2022, Zumper
 * @description  Constants for ProConData module
 */

export const CLEAR_PRO_CON_DATA = '@@nzr/Detail/CLEAR_PRO_CON_DATA' as const
export const DONE_FETCHING_PRO_CON_DATA = '@@nzr/Detail/DONE_FETCHING_PRO_CON_DATA' as const
export const ERROR_FETCHING_PRO_CON_DATA = '@@nzr/Detail/ERROR_FETCHING_PRO_CON_DATA' as const
export const RECEIVE_PRO_CON_DATA = '@@nzr/Detail/RECEIVE_PRO_CON_DATA' as const
export const START_FETCHING_PRO_CON_DATA = '@@nzr/Detail/START_FETCHING_PRO_CON_DATA' as const
